// функція сортування об'єктів по значенню
export const sortObj = (arr, element) => {
    return arr.sort((a,b) => a[element] - b[element]);
}